import type {
  AcceptorFunc,
  DogAcceptor,
  HorseAcceptor,
  IAcceptorEx,
  IRaceDetail,
  TrotAcceptor,
} from './types'

let getAcceptorDelegate: AcceptorFunc | null

export function getAcceptor(
  acceptorKey: string,
  acceptorNumber: number
): ReturnType<AcceptorFunc> | null {
  if (acceptorKey && getAcceptorDelegate) {
    const result = getAcceptorDelegate(acceptorKey)
    result.number = acceptorNumber
    return result
  }
  return null
}

export function setGetAcceptorFunc(func: AcceptorFunc) {
  getAcceptorDelegate = func
}
export function clearGetAcceptorFunc() {
  getAcceptorDelegate = null
}

export function isDog(acceptorToTest: IAcceptorEx | null): acceptorToTest is DogAcceptor {
  return !!acceptorToTest && 'boxNumber' in acceptorToTest
}

export function isHorse(acceptorToTest: IAcceptorEx | null): acceptorToTest is HorseAcceptor {
  return !!acceptorToTest && 'barrier' in acceptorToTest
}

export function isTrot(acceptorToTest: IAcceptorEx | null): acceptorToTest is TrotAcceptor {
  return !!acceptorToTest && 'handicap' in acceptorToTest
}

// Race Detail Callback
export type RaceDetailFunc = () => IRaceDetail
let getRaceDetailDelegate: RaceDetailFunc | null

export function getRaceDetail(): IRaceDetail | null {
  return getRaceDetailDelegate ? getRaceDetailDelegate() : null
}

export function setGetRaceDetailFunc(func: RaceDetailFunc) {
  getRaceDetailDelegate = func
}

// Select Acceptor Callback
export type SelectAcceptorFunc = (acceptorNumber: number, isFixed: boolean) => null
let selectAcceptorDelegate: SelectAcceptorFunc

export function selectAcceptor(acceptorNumber: number, isFixed: boolean): null {
  return selectAcceptorDelegate(acceptorNumber, isFixed)
}

export function setSelectAcceptorFunc(func: SelectAcceptorFunc) {
  selectAcceptorDelegate = func
}

// Clear Selection Callback
export type ClearSelectionFunc = () => void
let clearSelectionDelegate: ClearSelectionFunc

export function clearSelection(): void {
  // null guard is for backward compatability with mobi
  if (clearSelectionDelegate) {
    clearSelectionDelegate()
  }
}

export function setClearSelection(func: ClearSelectionFunc) {
  clearSelectionDelegate = func
}

// select quaddie callback
export type SelectQuaddieFunc = (raceNumbers: number[], acceptorNumbers: number[][]) => null
let selectQuaddieDelegate: SelectQuaddieFunc

export function selectQuaddie(raceNumbers: number[], acceptorNumbers: number[][]): null {
  return selectQuaddieDelegate(raceNumbers, acceptorNumbers)
}

export function setSelectQuaddieFunc(func: SelectQuaddieFunc) {
  selectQuaddieDelegate = func
}

export function isSelectQuaddieAllowed() {
  return selectQuaddieDelegate !== undefined
}
